import { type Color } from '@mui/material'

export const dhlRed = {
  100: '#331512',
  200: '#48211E',
  300: '#6B2522',
  400: '#9E2320',
  500: '#C12726',
  600: '#D73431',
  700: '#FF2626',
  800: '#FF7477',
  900: '#FFABB0',
} satisfies Partial<Color>
